import {
  cancelRequestEvent,
  cancelUndoEvent,
  reactivationEvent,
  renovationEvent,
  userDataEvent
} from '../../../utils/events/events'
import { rdReactivationEvent, rdRenovationEvent } from '../../../utils/events/eventsRdStation'

const EVENTOS_COMPRA = {
  'renovacao': { 'ga': renovationEvent, 'rd': rdRenovationEvent },
  'reativacao': { 'ga': reactivationEvent, 'rd': rdReactivationEvent }
}

function nomeCompleto( associado ) {
  if ( !associado ) {
    return ''
  }
  return [ associado.nome, associado.sobrenome ].filter( Boolean ).join( ' ' )
}

function extrairPagamento( data ) {
  return data?.venda?.pagamento || data?.assinatura?.vendas?.[ 0 ]?.pagamento || {}
}

function extrairPlanoId( data, assinatura ) {
  return data?.venda?.plano?.id || data?.assinatura?.plano?.id || assinatura?.planoId || null
}

function protegido( emissao ) {
  try {
    emissao()
  } catch ( erro ) {
    // eslint-disable-next-line no-console
    console.error( 'Não foi possível emitir os eventos do Bookster', erro )
  }
}

export function emitirEventosCompra( { tipo, data, assinatura, associado, metodoPagamento } ) {
  const eventos = EVENTOS_COMPRA[ tipo ]
  if ( !eventos ) {
    return
  }

  protegido( () => {
    const pagamento = extrairPagamento( data )
    const planId = extrairPlanoId( data, assinatura )
    const dadosCompra = {
      planId,
      'productPrice': Number( pagamento?.valor?.kit || 0 ),
      'freightPrice': Number( pagamento?.valor?.frete || 0 ),
      'totalDiscount': Number( pagamento?.desconto?.total || 0 ),
      'paymentHash': pagamento?.cobrancas?.[ 0 ]?.hash || null,
      'promotionCoupon': null
    }

    userDataEvent( {
      ...dadosCompra,
      'email': associado?.email || '',
      'name': nomeCompleto( associado ),
      'userId': associado?.id || null
    } )
    eventos.ga( { ...dadosCompra, 'paymentMethod': metodoPagamento } )
    eventos.rd( { planId, 'email': associado?.email || '' } )
  } )
}

export function emitirEventoCancelamento( { assinatura, motivos, origem } ) {
  protegido( () => {
    cancelRequestEvent( {
      'planId': assinatura?.planoId || null,
      'motivo': motivos?.motivo || null,
      'submotivo': motivos?.submotivo || null,
      origem
    } )
  } )
}

export function emitirEventoDesfazerCancelamento( { assinatura } ) {
  protegido( () => {
    cancelUndoEvent( { 'planId': assinatura?.planoId || null } )
  } )
}
